(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aio-WD-Collections"]) return;
  try {
    

/* tabs code start */
  
function initializeTabs() {
    var tabs;
    var tabContents;

    tabContents = document.getElementsByClassName('has-featured-collection-n1-wrapper-inner-content');
    tabs = document.getElementsByClassName('has-featured-collection-n1-tab');
    hideContent(1);

    document.getElementById('has-featured-collection-n1-tabs-content-inner').onclick = function (event) {
        var target = event.target;
        if (target.className == 'has-featured-collection-n1-tab') {
            for (var i = 0; i < tabs.length; i++) {
                if (target == tabs[i]) {
                    showContent(i);
                    break;
                }
            }
        }
    }

    function hideContent(indexToStart) {
        for (var i = indexToStart; i < tabContents.length; i++) {
            tabContents[i].classList.remove('show');
            tabContents[i].classList.add('hide');
            tabs[i].classList.remove('active');
        }
    }

    function showContent(indexToShow) {
        if (tabContents[indexToShow].classList.contains('hide')) {
            hideContent(0);
            tabs[indexToShow].classList.add('active');
            tabContents[indexToShow].classList.remove('hide');
            tabContents[indexToShow].classList.add('show');
        }
    }
}

initializeTabs();


/* tabs code end */
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aio-featured-collection-d"]) return;
  try {
    

/* tabs code start */

function initializeTabs() {
    var tabsd;
    var tabContentsd;

    tabContentsd = document.getElementsByClassName('has-featured-collection-d-wrapper-inner-content');
    tabsd = document.getElementsByClassName('has-featured-collection-d-tab');
    hideContent(1);

    document.getElementById('has-featured-collection-d-tabs-content-inner').onclick = function (event) {
        var target = event.target;
        if (target.className == 'has-featured-collection-d-tab') {
            for (var i = 0; i < tabsd.length; i++) {
                if (target == tabsd[i]) {
                    showContent(i);
                    break;
                }
            }
        }
    }

    function hideContent(indexToStart) {
        for (var i = indexToStart; i < tabContentsd.length; i++) {
            tabContentsd[i].classList.remove('show');
            tabContentsd[i].classList.add('hide');
            tabsd[i].classList.remove('active');
        }
    }

    function showContent(indexToShow) {
        if (tabContentsd[indexToShow].classList.contains('hide')) {
            hideContent(0);
            tabsd[indexToShow].classList.add('active');
            tabContentsd[indexToShow].classList.remove('hide');
            tabContentsd[indexToShow].classList.add('show');
        }
    }
}

initializeTabs();

/* tabs code end */
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aio-featured-collection-s"] && !Shopify.designMode) return;
  try {
    

   /* tabs code start */

function initializeTabs() {
    var tabsd;
    var tabContentsd;

    tabContentsd = document.getElementsByClassName('has-featured-collection-s-wrapper-inner-content');
    tabsd = document.getElementsByClassName('has-featured-collection-s-tab');
    hideContent(1);

    document.getElementById('has-featured-collection-s-tabs-content-inner').onclick = function (event) {
        var target = event.target;
        if (target.className == 'has-featured-collection-s-tab') {
            for (var i = 0; i < tabsd.length; i++) {
                if (target == tabsd[i]) {
                    showContent(i);
                    break;
                }
            }
        }
    }

    function hideContent(indexToStart) {
        for (var i = indexToStart; i < tabContentsd.length; i++) {
            tabContentsd[i].classList.remove('show');
            tabContentsd[i].classList.add('hide');
            tabsd[i].classList.remove('active');
        }
    }

    function showContent(indexToShow) {
        if (tabContentsd[indexToShow].classList.contains('hide')) {
            hideContent(0);
            tabsd[indexToShow].classList.add('active');
            tabContentsd[indexToShow].classList.remove('hide');
            tabContentsd[indexToShow].classList.add('show');
        }
    }
}

initializeTabs();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
